<template>
  <article class="flex flex-col">
    <h1 class="mb-[24px] font-roboto text-[32px] font-medium leading-6">
      Статьи
    </h1>
    <CommonComplexFiltering
      :key="isAnyFiltersActive"
      class="mb-[20px]"
      :rubrics-list="rubrics?.data?.value"
      :sort-options="sortOptions"
      :filters-active="filters"
    />
    <div class="-m-2.5 flex flex-wrap">
      <MainPageCardsReworkedBaseCard
        v-for="(article, index) in articles?.data?.value?.data"
        :key="`${article.id}_${index}`"
        :data="article"
        class="w-full max-w-[100%] p-2.5 sm:max-w-[50%] xl:max-w-[33.33333%]"
        disable-announce
      />
    </div>
    <BaseThePagination
      v-show="isDev"
      :paginate-pages="paginatePages"
      :total-pages="totalPages"
      :page="page"
      :view-page="viewPage"
      :offset="OFFSET"
    />

    <div class="mt-[64px] flex justify-center">
      <BaseTheButtonNew
        v-if="articles.hasNextPage.value"
        text="Показать еще"
        @click="articles.fetchNextPage()"
      />
    </div>
  </article>
</template>

<script setup>
const OFFSET = 3;

const route = useRoute();

const filters = computed(() => {
  return {
    sort_by: route.query?.sort_by,
    category: route.query?.category,
    startCentury: route.query?.startCentury,
    endCentury: route.query?.endCentury,
  };
});

const page = computed(() => Number(route.query?.page) || 1);
const viewPage = ref(page.value);
const { articles, resetPage } = useArticles({ filters, per_page: 9, page });
const totalPages = computed(() => articles?.data?.value?.meta?.last_page ?? 0);
const { rubrics } = useArticlesCategories();

const isDev = computed(() => {
  if (process.client) {
    return localStorage.getItem('isDev') === 'true';
  }
  return false;
});

const paginatePages = computed(() => {
  const arr = [];
  for (
    let i = Math.max(page.value - OFFSET, 1);
    i <= Math.min(page.value + OFFSET, totalPages.value);
    i++
  ) {
    arr.push(i);
  }
  return arr;
});

watch(
  () => articles?.data?.value?.meta?.current_page,
  (value) => {
    if (!value) return;
    viewPage.value = value;
  },
);

watch(filters, (_, prevValue) => resetPage(prevValue));

const isAnyFiltersActive = computed(() => Object.values(route.query).length);

const sortOptions = [
  { id: 0, label: 'Свежие', value: '', icon: 'timer' },
  {
    id: 1,
    label: 'Обсуждаемые',
    value: 'comments',
    icon: 'chat-circle',
  },
  { id: 2, label: 'Популярные', value: 'views', icon: 'eye' },
  { id: 3, label: 'Любимые', value: 'likes', icon: 'like' },
];

useHead({
  title:
    'История РФ: статьи для школьников и студентов | Читать на Федеральном портале Истории России',
  meta: [
    {
      name: 'description',
      content:
        'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
    },
    {
      name: 'keywords',
      content: 'История РФ: статьи для школьников и студентов',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: `https://histrf.ru${route.path}`,
    },
  ],
});
</script>
